import React from "react";
import { useI18n } from "@/lib/i18n";

/** Quiet scarcity line on a plan card. Renders nothing once the slots run out. */
export const EarlyAccessBadge = ({ earlyAccess, testId }) => {
  const { t } = useI18n();
  const left = Number(earlyAccess?.slots_left || 0);
  const total = Number(earlyAccess?.slots_total || 0);
  if (left <= 0 || total <= 0) return null;

  return (
    <p data-testid={testId}
      className="mt-3 font-mono-accent text-[10px] tracking-[0.14em] uppercase text-[#D4AF37]/80">
      {t("slots_left_badge", { left, total })}
    </p>
  );
};
